import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "about" */ './views/terms.page')
    },
    {
      path: '/docs',
      name: 'docs',
      component: () => import(/* webpackChunkName: "docs" */ './views/documentation/docs.page'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/quick-start.page'),
        },
        {
          path: 'trace-viewer',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/viewing-trace.page'),
        },
        {
          path: 'django-support',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/django-support.page'),
        },
        {
          path: 'variables-tracing',
          component: () => import(/* webpackChunkName: "docs" */ './views/documentation/trace-variables.page'),
        },

      ]
    },
    {
      path: '/my-profile',
      name: 'my-profile',
      component: () => import(/* webpackChunkName: "about" */ './views/my-profile.page')
    }
  ],
})
